(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-attention"] && !Shopify.designMode) return;
  try {
    
  // Collapsed-by-default on mobile, always open on desktop (mirrors the PDP info blocks).
  (function () {
    var mq = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
    function sync() {
      var mobile = mq ? mq.matches : false;
      document.querySelectorAll('.pdp-attn__disclosure[data-info-block]').forEach(function (d) { d.open = !mobile; });
    }
    sync();
    if (mq) { mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync); }
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-files-documents"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(root) {
      (root || document).querySelectorAll('.pdp-files-documents__summary').forEach(function (btn) {
        if (btn.dataset.docsBound) return;
        btn.dataset.docsBound = '1';
        btn.addEventListener('click', function () {
          var disclosure = btn.closest('.pdp-files-documents__disclosure');
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!expanded));
          if (disclosure) disclosure.classList.toggle('is-open', !expanded);
          if (panel) panel.setAttribute('aria-hidden', String(expanded));
        });
      });
    }
    document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
    else bind(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-tech-specs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Touch devices (no hover) open the modal on tap. Desktop relies on the hover
    // tooltip only — clicking a tile there does nothing.
    var touch = window.matchMedia ? window.matchMedia('(hover: none)') : { matches: false };
    function text(el) { return el ? (el.textContent || '').trim() : ''; }
    function openModal(btn) {
      var block = btn.closest('.pdp-info__block');
      var modal = block && block.querySelector('[data-tech-modal]');
      if (!modal) return;
      var pop   = document.getElementById(btn.getAttribute('aria-describedby'));
      var icon  = modal.querySelector('[data-tech-modal-icon]');
      var title = modal.querySelector('[data-tech-modal-title]');
      var desc  = modal.querySelector('[data-tech-modal-desc]');
      // reuse the tile's already-loaded image URL → modal icon shows instantly (no refetch)
      var tileImg = btn.querySelector('.pdp-tech__icon');
      var src   = (tileImg && tileImg.tagName === 'IMG') ? (tileImg.currentSrc || tileImg.src) : '';
      if (icon) {
        if (src) { icon.setAttribute('src', src); icon.style.display = ''; }
        else { icon.removeAttribute('src'); icon.style.display = 'none'; }
      }
      if (title) title.textContent = pop ? text(pop.querySelector('.pdp-tech__pop-title')) : (btn.getAttribute('aria-label') || '');
      if (desc)  desc.textContent  = pop ? text(pop.querySelector('.pdp-tech__pop-desc')) : '';
      modal._opener = btn;
      if (typeof modal.showModal === 'function') { try { modal.showModal(); } catch (e) { modal.setAttribute('open', ''); } }
      else modal.setAttribute('open', '');
    }
    function closeModal(modal) {
      if (typeof modal.close === 'function') { try { modal.close(); } catch (e) { modal.removeAttribute('open'); } }
      else modal.removeAttribute('open');
      if (modal._opener) { try { modal._opener.focus(); } catch (e) {} }
    }
    function bind(root) {
      (root || document).querySelectorAll('[data-tech-open]').forEach(function (btn) {
        if (btn.dataset.techBound) return; btn.dataset.techBound = '1';
        btn.addEventListener('click', function () { if (touch.matches) openModal(btn); });
      });
      (root || document).querySelectorAll('[data-tech-modal]').forEach(function (modal) {
        if (modal.dataset.techBound) return; modal.dataset.techBound = '1';
        var x = modal.querySelector('[data-tech-close]');
        if (x) x.addEventListener('click', function () { closeModal(modal); });
        // click on the backdrop (the dialog element itself, outside the inner box) closes
        modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(modal); });
      });
    }
    document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
    else bind(document);
  })();

  // ── Collapsible info blocks: collapsed-by-default on mobile, always open on desktop ──
  (function () {
    var mq = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
    function sync() {
      var mobile = mq ? mq.matches : false;
      document.querySelectorAll('details[data-info-block]').forEach(function (d) {
        d.open = !mobile;
      });
    }
    sync();
    if (mq) { mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync); }
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // A YouTube video with no maxresdefault gets a 120x90 grey placeholder, not
    // an error, so check the decoded size rather than listening for onerror.
    function fixPoster(img) {
      var fallback = img.getAttribute('data-poster-fallback');
      if (!fallback) return;
      if (img.naturalWidth > 0 && img.naturalWidth <= 120) {
        img.removeAttribute('data-poster-fallback');
        img.src = fallback;
      }
    }

    function bindPosters(root) {
      (root || document).querySelectorAll('.pdp-video__poster[data-poster-fallback]').forEach(function (img) {
        if (img.complete) fixPoster(img);
        img.addEventListener('load', function () { fixPoster(img); }, { once: true });
        img.addEventListener('error', function () {
          var fallback = img.getAttribute('data-poster-fallback');
          if (fallback) { img.removeAttribute('data-poster-fallback'); img.src = fallback; }
        }, { once: true });
      });
    }

    function bind(root) {
      bindPosters(root);
      (root || document).querySelectorAll('.pdp-video__play').forEach(function (btn) {
        if (btn.dataset.videoBound) return;
        btn.dataset.videoBound = '1';
        btn.addEventListener('click', function () {
          var frame = btn.closest('.pdp-video__frame');
          if (!frame) return;
          var file = frame.querySelector('template[data-pdp-video-file]');
          if (file) {
            var video = file.content.querySelector('video').cloneNode(true);
            frame.replaceChildren(video);
            // Still inside the click, so the browser allows playback with sound.
            video.play().catch(function () {});
            video.focus();
            return;
          }
          var iframe = document.createElement('iframe');
          iframe.className = 'pdp-video__iframe';
          iframe.src = btn.getAttribute('data-pdp-video');
          iframe.title = btn.getAttribute('data-pdp-video-title') || '';
          iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
          iframe.allowFullscreen = true;
          iframe.setAttribute('loading', 'eager');
          frame.replaceChildren(iframe);
          // The poster button is gone, so move focus into the player for keyboard users.
          iframe.focus();
        });
      });
    }
    document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
    else bind(document);
  })();

  } catch(e) { console.error(e); }
})();
})();
